
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Viewer from 'v-viewer'
import VueVideoPlayer from 'vue-video-player'
import '../static/css/global.css' /*引入公共样式*/
import '../static/css/theme.css' /*引入主题样式*/

import '../static/themeCss/xyTheme.scss' /*引入浅色主题样式*/
import '../static/themeCss/xyTheme_black.scss' /*引入深色主题样式*/

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import '../static/icon/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'viewerjs/dist/viewer.css'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import store from './store'
import axios from 'axios'
import base from './components/Common/base.js'
import $ from 'jquery'
import moment from 'moment'
import VueClipboard from 'vue-clipboard2'
import { JSEncrypt } from 'jsencrypt'//密码加密
import echarts from "echarts";
import global_ from './components/Common/Global'//全局变量文件

Vue.use(VueClipboard)
Vue.use(require('vue-moment'));
Vue.prototype.moment = moment
Vue.prototype.GLOBAL = global_
Vue.config.productionTip = false

//英文版本，將element UI换成英文
if(window.location.href.indexOf('Lang=EN') > -1){
  Vue.use(ElementUI, { locale })
}else{
  Vue.use(ElementUI)
}
Vue.use(base).use(Viewer).use(VueVideoPlayer);

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios
Vue.prototype.$encryptedData = function(publicKey, obj) {
  //new一个对象
  let encrypt = new JSEncrypt()
  //设置公钥
  encrypt.setPublicKey(publicKey)
  //obj是要加密的数据,此处不用注意+号,因为rsa自己本身已经base64转码了,不存在+,全部是二进制数据
  let result = encrypt.encrypt(obj)
  return result
}

Vue.prototype.APIURL = process.env.NODE_ENV === 'development' ? window.APIURL.devUrlApi : window.APIURL.prodUrlApi;
Vue.prototype.homeUrl = window.APIURL.homeUrl;
// 全局时间戳转换时间
Vue.filter('dateYMDHMSFormat',function(dateStr,pattern='YYYY-MM-DD HH:mm:ss'){
  return moment(dateStr).format(pattern);
});
Vue.filter('dateYMDHMSFormat2',function(dateStr,pattern='YYYY-MM-DD'){
  return moment(dateStr).format(pattern);
});

//获取语言包
let jsonApi = '';
let language_Json = null;
if(window.location.href.indexOf('Lang=EN') > -1){
  jsonApi = window.location.origin + window.location.pathname + 'static/EN.json'; //英文语言包
}else if(window.location.href.indexOf('Lang=TC') > -1){
  jsonApi = window.location.origin + window.location.pathname + 'static/TC.json'; //繁体语言包
}

if(jsonApi){
  axios({
    url: jsonApi
  }).then(res => {
    language_Json = res.data;
  })
}

//匹配语言
function getLanguage(str){
  if(str && language_Json){
    str = language_Json[str]?language_Json[str]:str;
  }
  return str
}

//注册语言方法
Vue.prototype.Language = (str)=>{
  return getLanguage(str)
}

//注册提示方法
Vue.prototype.$Msg = {
  error(msg){
    ElementUI.Message.error({
      message: getLanguage(msg)
    });
  },
  success(msg){
    ElementUI.Message.success({
      message: getLanguage(msg)
    });
  }
}

// 图片预览插件配置
Viewer.setDefaults({
  defaultOptions: {
    zIndex: 9999
  },
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source"
  }
})

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  // render: h => h(App),
  components: { App },

})




// WEBPACK FOOTER //
// ./src/main.js